import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const link = "text-sm text-slate-300 hover:text-amber-300 transition-colors whitespace-nowrap";

export const PublicNav = () => {
  const { user } = useAuth();
  return (
    <nav className="flex items-center gap-2.5 sm:gap-4" data-testid="public-nav">
      <Link to="/features" className={link} data-testid="nav-features-link">Features</Link>
      <Link to="/pricing" className={link} data-testid="nav-pricing-link">Pricing</Link>
      <span aria-hidden="true" className="h-5 w-px bg-slate-500/50" data-testid="nav-divider" />
      {user ? (
        <Link to="/worlds" className={link} data-testid="nav-my-worlds-link">My worlds</Link>
      ) : (
        <>
          <Link to="/login" className={link} data-testid="nav-login-link">Sign in</Link>
          <Link to="/register" className="text-sm whitespace-nowrap rounded-full border border-amber-500/40 px-3 sm:px-4 py-2 text-amber-200 hover:bg-amber-500/10 transition-colors" data-testid="nav-register-link">Begin</Link>
        </>
      )}
    </nav>
  );
};
